import { render, staticRenderFns } from "./FifthBlockEvents.vue?vue&type=template&id=3e3a91db"
import script from "./FifthBlockEvents.vue?vue&type=script&lang=js"
export * from "./FifthBlockEvents.vue?vue&type=script&lang=js"
import style0 from "./FifthBlockEvents.vue?vue&type=style&index=0&id=3e3a91db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports